var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$auth.ADMIN && this.handsRaisedCount > 0)?_c('div',{staticClass:"hands-raised-container"},[_c('div',{staticClass:"raised-hands"},[_c('div',{staticClass:"display-count-parent"},[_c('span',[_vm._v(_vm._s(_vm.handsRaisedCount)+" "+_vm._s(_vm.handsRaisedText))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }